import styled from "styled-components";

export const InputRadioContainerStyle = styled.label`
  display: flex;
  gap: 0 8px;
  align-items: center;
  position: relative;
  cursor: pointer;

  span {
    color: #111;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
  }

  input {
    opacity: 0;
    position: absolute;
  }
`;

export const imgChecked = styled.img``;
export const imgUnchecked = styled.img`
  width: 16px;
  height: 16px;
`;

export const WrapperImg = styled.div``;
